import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMinus = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 12,
	viewBox: "0 0 20 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.2499 5.06055C16.5103 5.06055 16.7708 5.13867 16.9661 5.25586C17.1614 5.37305 17.2916 5.5293 17.2916 5.68555V6.31055C17.2916 6.48633 17.1614 6.64258 16.9661 6.75977C16.7708 6.87695 16.5103 6.93555 16.2499 6.93555H3.74992C3.45695 6.93555 3.19653 6.87695 3.00122 6.75977C2.80591 6.64258 2.70825 6.48633 2.70825 6.31055V5.68555C2.70825 5.5293 2.80591 5.37305 3.00122 5.25586C3.19653 5.13867 3.45695 5.06055 3.74992 5.06055H16.2499Z",
		fill: "currentColor"
	})
});
export default SvgMinus;
